import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initializeAnalytics, trackPageView } from "../analytics";
import { CONSENT_EVENT, getConsent } from "../consent";

export const GoogleAnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (getConsent() !== "accepted") return;
    initializeAnalytics();
    trackPageView();
  }, [location.pathname, location.search, location.hash]);

  useEffect(() => {
    const onConsent = (e) => {
      if (e.detail !== "accepted") return;
      initializeAnalytics();
      trackPageView();
    };
    window.addEventListener(CONSENT_EVENT, onConsent);
    return () => window.removeEventListener(CONSENT_EVENT, onConsent);
  }, []);

  return null;
};

export default GoogleAnalyticsTracker;
